import FJSharedCreations from './FJSharedCreations';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../../hooks/useLocalStore';
import { useEffect, useMemo, useCallback } from 'react';
import FJActionCommunity from '../../../../../redux/action/FJActionCommunity';
import FJConstant from '../../../../../constants/FJConstant';
const FJSharedCreationsContainer = props => {
    const { active } = props;
    const dispatch = useDispatch();
    const sharedCreationsList = useSelector(state => state.community.sharedCreationsList);
    const multipleSelectedList = useSelector(state => state.community.multipleSelectedList);
    const sharedCreationsPageInfo = useSelector(state => state.community.sharedCreationsPageInfo);
    const guestUserInfo = useSelector(state => state.community.guestUserInfo);
    useLocalStore();
    useEffect(() => {
        dispatch(FJActionCommunity.initSharedCreationsListAction());
    }, [dispatch]);

    const getMoreSharedCreationsListAction = useCallback(() => {
        dispatch(FJActionCommunity.getMoreSharedCreationsListAction());
    }, [dispatch]);
    const changeMySpaceTabToCreations = useCallback(() => {
        dispatch(FJActionCommunity.changeMySpaceTabTypeAction(FJConstant.MY_CREATIONS));
    }, [dispatch]);
    const isMultipleSelect = useMemo(() => {
        return multipleSelectedList.length > 0;
    }, [multipleSelectedList]);
    return (
        <FJSharedCreations
            active={active}
            sharedCreationsList={sharedCreationsList}
            getMoreSharedCreationsData={getMoreSharedCreationsListAction}
            isMultipleSelect={isMultipleSelect}
            multipleSelectedList={multipleSelectedList}
            sharedCreationsPageInfo={sharedCreationsPageInfo}
            changeMySpaceTabToCreations={changeMySpaceTabToCreations}
            guestUserInfo={guestUserInfo}
        />
    );
};
FJSharedCreationsContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};
export default FJSharedCreationsContainer;
